/****************************************************
 * Module Name:  exchangerateProxy.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import restAPICall from "../../api/restAPICall";
import Constants from "../../constants";

export default class ExchangerateProxy {
  static GetAllExchangerate = (callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/exchangerate",
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetSingleExchangerate = (exchangerateId, callback) => {
    let params = {
      id: exchangerateId,
    };

    restAPICall(
      Constants.MANAGER_URL + "/exchangerate",
      "get",
      Constants.userToken,
      params,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static CheckExchangedateAvailable = (exchangedate, callback) => {
    let params = {
      exchangedate: exchangedate,
    };

    restAPICall(
      Constants.MANAGER_URL + "/exchangerate/available",
      "get",
      Constants.userToken,
      params,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static AddExchangerate = (exchangerate, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/exchangerate",
      "post",
      Constants.userToken,
      undefined,
      JSON.stringify(exchangerate),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static UpdateExchangerate = (exchangerate, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/exchangerate",
      "put",
      Constants.userToken,
      undefined,
      JSON.stringify(exchangerate),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static DeleteExchangerate = (exchangerate, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/exchangerate",
      "delete",
      Constants.userToken,
      undefined,
      JSON.stringify(exchangerate),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };
}
